export default "__VITE_ASSET__fNLg9mw___"